import React, { memo } from 'react';

import { UniversityCardProps } from '@components/EducationCard/UniversityCard/UniversityCard.types';
import { UniversityIcon } from './UniversityIcon';
import { UniversityInfo } from './UniversityInfo';

import { UniversityBox, UniversityContainer } from './UnivercityCard.styled';

export const UniversityCard = memo(
  ({
    background,
    shadow,
    themeType,
    titleColor,
    textColor,
  }: UniversityCardProps) => (
    <UniversityContainer>
      <UniversityBox background={background} shadow={shadow}>
        <UniversityIcon themeType={themeType} />
        <UniversityInfo
          customTextColor={textColor}
          customTitleColor={titleColor}
        />
      </UniversityBox>
    </UniversityContainer>
  ),
);
